import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["selectedIcon", "selected", "role", "tabIndex", "focused", "children", "value", "onClick", "tokens"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { transparentize } from 'polished';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import { useMenuListState } from './MenuListContext';
import * as views from './MenuListItem.views';
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var BaseMenuListItem = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var selectedIcon = _ref.selectedIcon,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? false : _ref$selected,
      role = _ref.role,
      tabIndex = _ref.tabIndex,
      focused = _ref.focused,
      children = _ref.children,
      value = _ref.value,
      _onClick = _ref.onClick,
      tokens = _ref.tokens,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useMenuListState = useMenuListState(),
      interactive = _useMenuListState.interactive,
      onInternalClick = _useMenuListState.onClick;

  return _jsxs(views.MenuListItem, _objectSpread(_objectSpread(_objectSpread({}, rest), {}, {
    onClick: function onClick(e) {
      onInternalClick === null || onInternalClick === void 0 ? void 0 : onInternalClick(e, value);
      _onClick === null || _onClick === void 0 ? void 0 : _onClick(e);
    },
    selected: selected,
    "aria-selected": selected,
    role: role,
    tabIndex: tabIndex,
    focused: focused,
    interactive: interactive,
    ref: ref
  }, tokens), {}, {
    children: [children, selected && selectedIcon]
  }));
});
export var MenuListItem = withDesignTokens(BaseMenuListItem, function (props) {
  return {
    selectedFontWeight: 500,
    hasSelectedIcon: Boolean(props.selectedIcon)
  };
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[700],
      focusBackgroundColor: theme.palette.brand.darkAcai[100],
      activeBackgroundColor: theme.palette.brand.darkAcai[200],
      selectedBackgroundColor: theme.palette.brand.segmentGreen[100],
      selectedColor: theme.palette.brand.segmentGreen[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.neutrals.white[100],
      focusBackgroundColor: transparentize(0.95, theme.palette.neutrals.white[100]),
      activeBackgroundColor: theme.palette.brand.darkAcai[500],
      selectedBackgroundColor: transparentize(0.95, theme.palette.brand.darkAcai[600]),
      selectedColor: theme.palette.brand.segmentGreen[500]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100],
      focusBackgroundColor: theme.palette.twilio.gray[10],
      activeBackgroundColor: theme.palette.twilio.gray[30],
      selectedBackgroundColor: theme.palette.twilio.blue[10],
      selectedColor: theme.palette.twilio.blue[60]
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      color: theme.palette.twilio.gray[100],
      focusBackgroundColor: theme.palette.twilio.gray[10],
      activeBackgroundColor: theme.palette.twilio.gray[30],
      selectedBackgroundColor: theme.palette.twilio.blue[10],
      selectedColor: theme.palette.twilio.blue[60]
    };
  }
});